import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper'
import IMG_1 from 'assets/images/apps/img-app-screen-1.png'
import IMG_2 from 'assets/images/apps/img-app-screen-2.png'
import IMG_3 from 'assets/images/apps/img-app-screen-3.png'
import IMG_4 from 'assets/images/apps/img-app-screen-4.png'
import IMG_5 from 'assets/images/apps/img-app-screen-5.png'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

/**
 * @file 어플리케이션 화면에서 앱 캡쳐 영역의 swiper
 */
function ApplicationAppSwiper() {
    return (
        <>
            <Swiper
                className="swiper-application"
                direction="horizontal"
                //slidesPerView={3} // 한 슬라이드에 보여줄 개수
                slidesPerView="auto" // 한 슬라이드에 보여줄 개수
                spaceBetween={44}
                loop={true}
                modules={[Navigation, Pagination]}
                navigation={{
                    nextEl: '.application-five .slide-control-btn.next',
                    prevEl: '.application-five .slide-control-btn.prev',
                }}
                pagination={{
                    el: '.swiper-pagination',
                    enabled: true,
                    clickable: true,
                    //renderBullet: function (index, className) {
                    //return `<span class="${className}" style="background-color:#ff0000"></span>`;
                    //},
                }}
                breakpoints={{
                    100: {
                        centeredSlides: false,
                        //slidesPerView: 3,
                        spaceBetween: 17,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                    1000: {
                        slidesPerView: 2,
                        spaceBetween: 44,
                    },
                }}>
                <div className="swiper-wrapper">
                    <SwiperSlide className="swiper-slide">
                        <img src={IMG_1} alt="" />
                        {/* <div className="text-box">
              <div className="t1">차세대 인터페이스</div>
              <div className="sub">
                최적화 된 인터페이스로 보기 편하고 유용한 사용성을 제공합니다. 주차위치, 주행가능거리, 타이어 공기압,
                차량 진단, 실제 차량 상태까지 한 눈에 전체 정보를 확인할 수 있도록 도와줍니다.
              </div>
            </div> */}
                    </SwiperSlide>
                    <SwiperSlide className="swiper-slide">
                        <img src={IMG_2} alt="" />
                        {/* <div className="text-box">
              <div className="t1">차세대 인터페이스</div>
              <div className="sub">
                최적화 된 인터페이스로 보기 편하고 유용한 사용성을 제공합니다. 주차위치, 주행가능거리, 타이어 공기압,
                차량 진단, 실제 차량 상태까지 한 눈에 전체 정보를 확인할 수 있도록 도와줍니다.
              </div>
            </div> */}
                    </SwiperSlide>
                    <SwiperSlide className="swiper-slide">
                        <img src={IMG_3} alt="" />
                        {/* <div className="text-box">
              <div className="t1">차세대 인터페이스</div>
              <div className="sub">
                최적화 된 인터페이스로 보기 편하고 유용한 사용성을 제공합니다. 주차위치, 주행가능거리, 타이어 공기압,
                차량 진단, 실제 차량 상태까지 한 눈에 전체 정보를 확인할 수 있도록 도와줍니다.
              </div>
            </div> */}
                    </SwiperSlide>
                    <SwiperSlide className="swiper-slide">
                        <img src={IMG_4} alt="" />
                        {/* <div className="text-box">
              <div className="t1">차세대 인터페이스</div>
              <div className="sub">
                최적화 된 인터페이스로 보기 편하고 유용한 사용성을 제공합니다. 주차위치, 주행가능거리, 타이어 공기압,
                차량 진단, 실제 차량 상태까지 한 눈에 전체 정보를 확인할 수 있도록 도와줍니다.
              </div>
            </div> */}
                    </SwiperSlide>
                    <SwiperSlide className="swiper-slide">
                        <img src={IMG_5} alt="" />
                        {/* <div className="text-box">
              <div className="t1">차세대 인터페이스</div>
              <div className="sub">
                최적화 된 인터페이스로 보기 편하고 유용한 사용성을 제공합니다. 주차위치, 주행가능거리, 타이어 공기압,
                차량 진단, 실제 차량 상태까지 한 눈에 전체 정보를 확인할 수 있도록 도와줍니다.
              </div>
            </div> */}
                    </SwiperSlide>
                </div>
            </Swiper>
        </>
    )
}

export default ApplicationAppSwiper
